import React from "react";
import { InfoIcon } from "../../../../svg/info-icon";

interface BadgeCellProps {
  value: {
    text: string;
    color?: string;
    bgColor?: string;
    displayText?: string;
    showInfoIcon?: boolean;
    hoverText?: string;
  };
  [key: string]: any;
}

/**
 * Renders a colored badge (and optional info icon) for table cells.
 * When `showInfoIcon` is false, the native tooltip uses `hoverText` or `displayText`
 * on the full-width wrapper so hovering the cell area still shows the title.
 *
 * @param value - Badge label, colors, and optional tooltip fields
 * @returns Badge markup for the standard badge table cell type
 */
export const BadgeCell: React.FC<BadgeCellProps> = ({ value }) => {
  const nonInfoTooltip = !value.showInfoIcon
    ? value.hoverText || value.displayText
    : undefined;

  return (
    <div
      className="flex h-full w-full flex-row items-center gap-1"
      title={nonInfoTooltip}
    >
      <div
        className="table-cell-badge"
        style={{
          color: value.color || "#000000",
          backgroundColor: value.bgColor || "#F5F5F5",
        }}
        title={value.showInfoIcon ? value.displayText : undefined}
      >
        {value.text}
      </div>
      {value.showInfoIcon && (
        <div title={value.hoverText} className="cursor-pointer">
          <InfoIcon />
        </div>
      )}
    </div>
  );
};

export default BadgeCell;
